import { jsx as e, jsxs as h, Fragment as m } from "react/jsx-runtime";
import { Slot as x } from "@radix-ui/react-slot";
import { cva as y } from "class-variance-authority";
import { Loader2 as k } from "lucide-react";
import * as w from "react";
import { cn as z } from "../lib/utils.js";
const N = y(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-hidden focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "text-destructive hover-text-foreground bg-secondary border border-border hover:text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:hover:bg-destructive/60",
        outline: "border bg-surface shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), _ = w.forwardRef(
  ({
    className: a,
    variant: d,
    size: c,
    asChild: r = !1,
    loading: t = !1,
    disabled: u,
    children: o,
    icon: s,
    iconPlacement: i = "left",
    effect: j,
    ...v
  }, f) => {
    const g = r ? x : "button", l = u || t, p = t && !r, n = s && !t, b = r ? o : /* @__PURE__ */ h(m, { children: [
      p && /* @__PURE__ */ e(k, { className: "animate-spin" }),
      n && i === "left" && /* @__PURE__ */ e(s, { className: "size-4" }),
      o,
      n && i === "right" && /* @__PURE__ */ e(s, { className: "size-4" })
    ] });
    return /* @__PURE__ */ e(
      g,
      {
        className: z(N({ variant: d, size: c, className: a })),
        ref: f,
        disabled: l,
        "data-slot": "button",
        ...v,
        children: b
      }
    );
  }
);
_.displayName = "Button";
export {
  _ as Button,
  N as buttonVariants
};
